import { actions } from '@bt-react/store'
import { debug } from '@bt-react/libs/Logger'
import { status as Status } from '@bt-react/constants'
import { docsType } from './'
import { SyncDocument, SyncMap, SyncClient } from 'twilio-sync'
import { State } from '../../reducers/reducerType'
import twilioSyncConnect from '../../../services/sync'
import { setSeatingOrderMap } from '../seatingOrder/seatingOrderActions'
import { addEntry } from '../../../lib/audit'
import { setInitialPresenterControlState } from '../tracks/trackActions'
import playInActions from '../playIns'
import slidesActions from '../slides'
import checkRescheduleConfirmation from '../../../lib/checkRescheduleConfirmation'
import { showRescheduleModal } from '../ui/uiActions'
import { WATCH } from '../../../dataStore/constants/roles'

export const fetchSyncDocuments = (client: SyncClient) => async (dispatch, getState: () => State) => {

  dispatch({ type: docsType.FETCH_SYNC_DOCS })
  const state = getState()
  const { roomname } = state.config
  const { user } = state
  let syncObjects: (SyncDocument | SyncMap)[] = []

  if (!roomname) return dispatch({ type: docsType.FETCH_SYNC_DOCS_ERROR })

  try {

    syncObjects = await twilioSyncConnect(client, roomname)

  }
  catch (e) {

    debug(e.message)
    return dispatch({ type: docsType.FETCH_SYNC_DOCS_ERROR })

  }

  const [ uiDoc, bookingDoc, playInDoc, bridgeDataDoc, slideDoc, questionsDoc, seatingOrderMap ] = syncObjects

  /*@ts-ignore*/
  const seatingOrderData = await seatingOrderMap.getItems()

  addEntry('PresenterService', 'DocumentsFetched', JSON.stringify({
    localTimestamp: Date.now().toString(),
    userId: user.BTID,
    name: `${user.data?.firstName} ${user.data?.lastName}`,
      /*@ts-ignore*/
    data: syncObjects.map((doc) => doc.syncDocumentImpl ? doc.syncDocumentImpl.descriptor : {...doc.syncMapImpl.descriptor, data: seatingOrderData.items})
  }))

  uiDoc.setTtl(86400)
  playInDoc.setTtl(7890000)

  uiDoc.on('updated', (values) => {
    addEntry('PresenterService', 'DocumentUpdated', JSON.stringify({
      localTimestamp: Date.now().toString(),
      userId: user.BTID,
      name: `${user.data?.firstName} ${user.data?.lastName}`,
      document: 'uiDoc',
      data: values,
      /*@ts-ignore*/
      descriptor: uiDoc.syncDocumentImpl.descriptor
    }))
  })
  bookingDoc.on('updated', (values) => {
    addEntry('PresenterService', 'DocumentUpdated', JSON.stringify({
      localTimestamp: Date.now().toString(),
      userId: user.BTID,
      name: `${user.data?.firstName} ${user.data?.lastName}`,
      document: 'bookingDoc',
      data: values,
      /*@ts-ignore*/
      descriptor: bookingDoc.syncDocumentImpl.descriptor
    }))
  })
  playInDoc.on('updated', (values) => {
    addEntry('PresenterService', 'DocumentUpdated', JSON.stringify({
      localTimestamp: Date.now().toString(),
      userId: user.BTID,
      name: `${user.data?.firstName} ${user.data?.lastName}`,
      document: 'playInDoc',
      data: values,
      /*@ts-ignore*/
      descriptor: playInDoc.syncDocumentImpl.descriptor
    }))
  })
  bridgeDataDoc.on('updated', (values) => {
    addEntry('PresenterService', 'DocumentUpdated', JSON.stringify({
      localTimestamp: Date.now().toString(),
      userId: user.BTID,
      name: `${user.data?.firstName} ${user.data?.lastName}`,
      document: 'bridgeDataDoc',
      data: values,
      /*@ts-ignore*/
      descriptor: bridgeDataDoc.syncDocumentImpl.descriptor
    }))
  })
  slideDoc.on('updated', (values) => {
    addEntry('PresenterService', 'DocumentUpdated', JSON.stringify({
      localTimestamp: Date.now().toString(),
      userId: user.BTID,
      name: `${user.data?.firstName} ${user.data?.lastName}`,
      document: 'slideDoc',
      data: values,
      /*@ts-ignore*/
      descriptor: slideDoc.syncDocumentImpl.descriptor
    }))
  })
  seatingOrderMap.on('itemUpdated', async (values) => {
    /*@ts-ignore*/
    const allMapData = await seatingOrderMap.getItems()
    addEntry('PresenterService', 'DocumentUpdated', JSON.stringify({
      localTimestamp: Date.now().toString(),
      userId: user.BTID,
      name: `${user.data?.firstName} ${user.data?.lastName}`,
      document: 'seatingOrderMap',
      type: 'updated',
      data: values,
      allData: allMapData.items,
      /*@ts-ignore*/
      descriptor: seatingOrderMap.syncMapImpl.descriptor
    }))
  })

  seatingOrderMap.on('itemAdded', async (values) => {
    /*@ts-ignore*/
    const allMapData = await seatingOrderMap.getItems()
    addEntry('PresenterService', 'DocumentUpdated', JSON.stringify({
      localTimestamp: Date.now().toString(),
      userId: user.BTID,
      name: `${user.data?.firstName} ${user.data?.lastName}`,
      document: 'seatingOrderMap',
      type: 'added',
      data: values,
      allData: allMapData.items,
      /*@ts-ignore*/
      descriptor: seatingOrderMap.syncMapImpl.descriptor
    }))
  })

  seatingOrderMap.on('itemRemoved', async (values) => {
    /*@ts-ignore*/
    const allMapData = await seatingOrderMap.getItems()
    addEntry('PresenterService', 'DocumentUpdated', JSON.stringify({
      localTimestamp: Date.now().toString(),
      userId: user.BTID,
      name: `${user.data?.firstName} ${user.data?.lastName}`,
      document: 'seatingOrderMap',
      type: 'removed',
      data: values,
      allData: allMapData.items,
      /*@ts-ignore*/
      descriptor: seatingOrderMap.syncMapImpl.descriptor
    }))
  })

  dispatch(setUIDocument(uiDoc))
  dispatch(setBookingDocument(bookingDoc))
  dispatch(setPlayInDocument(playInDoc))
  dispatch(setBridgeDataDocument(bridgeDataDoc))
  dispatch(setSlidesDocument(slideDoc))
  dispatch(setQuestionsDocument(questionsDoc))
  dispatch(setSeatingOrderMap(seatingOrderMap as SyncMap))
  dispatch({ type: docsType.FETCH_SYNC_DOCS_SUCCESS })

}
export const removeUIDoc = () => ({ type: docsType.REMOVE_UI_DOC })
export const handleUiDocRemovedEvent = () => (dispatch) => {

  debug(`UI document has been removed`)
  dispatch(removeUIDoc())
  dispatch(resetSession())

}
export const docUIListenersAdded = () => ({ type: docsType.DOCUMENT_UI_LISTENERS_ADDED })
export const setUIDocument = doc => (dispatch, getState) => {

  const {
    user: {
      BTID
    }
  } = getState()

  setInitialPresenterControlState(BTID, doc)
  dispatch({ type: docsType.SET_UI_DOCUMENT, payload: doc })

}
export const setBookingDocument = (doc: SyncDocument | SyncMap) => ({ type: docsType.SET_BOOKING_DOCUMENT, payload: doc })
export const setPlayInDocument = (doc: SyncDocument | SyncMap) => (dispatch, getState) => {

  const { featureFlags } = getState().config

  if (!featureFlags.playIn) return

  dispatch(playInActions.setPlayIn(doc))
  dispatch({ type: docsType.SET_PLAY_IN_DOCUMENT, payload: doc })

}
export const setSlidesDocument = (doc: SyncDocument | SyncMap) => (dispatch, getState) => {

  const { featureFlags } = getState().config

  if (!featureFlags.slides) return

  dispatch(slidesActions.setSlides(doc))
  dispatch({ type: docsType.SET_SLIDES_DOCUMENT, payload: doc })

}
export const docBookingListenersAdded = () => ({ type: docsType.DOCUMENT_BOOKING_LISTENERS_ADDED })
export const setBridgeDataDocument = (bridgeDataDocument: SyncDocument | SyncMap) => ({ type: docsType.SET_BRIDGE_DATA_DOCUMENT, payload: bridgeDataDocument })
export const removeBridgeDataDocument = () => ({ type: docsType.REMOVE_BRIDGE_DATA_DOCUMENT })
export const removeBookingDoc = () => ({ type: docsType.REMOVE_BOOKING_DOC })
export const setBookingStatus = (status) => async (dispatch, getState) => {

  const { docs: { uiDoc }, ui: { isEndRequested }, user } = getState()
  const { LIVE_ENABLED, GOING_LIVE, PRE_ROLL_INTERSTITIAL } = Status
  const userName = user.data?.firstName + ' ' + user.data?.lastName

  if (
    uiDoc.data.goingLive &&
    [LIVE_ENABLED, GOING_LIVE, PRE_ROLL_INTERSTITIAL].filter(testStatus => testStatus === status).length === 0
  ) uiDoc.update({ goingLive: false })

  if (isEndRequested && status !== Status.LIVE) uiDoc.update({ endingLive: false })

  if (status === Status.RESCHEDULED && getState().config.role !== WATCH) {

    if (checkRescheduleConfirmation(getState())) dispatch(showRescheduleModal())

    try {

      const { webcastId, channelId } = getState().config

      dispatch(actions.fetchPublicWebcastData(channelId, webcastId))

    }
    catch (e) {

      console.log(e)

    }

  }


  addEntry('PresenterService', 'DocumentUpdated', `Booking status updated for ${userName || user.BTID}. Status: ${status}`)
  dispatch({ type: docsType.SET_BOOKING_STATUS, payload: status })

}
export const setQuestionsDocument = (doc: SyncDocument | SyncMap) => (dispatch, getState) => dispatch({ type: docsType.SET_QUESTIONS_DOCUMENT, payload: doc})
export const resetSession = () => ({ type: docsType.RESET_SESSION })


export default {
  fetchSyncDocuments,
  removeUIDoc,
  handleUiDocRemovedEvent,
  docUIListenersAdded,
  setUIDocument,
  setBookingDocument,
  setPlayInDocument,
  setSlidesDocument,
  setBridgeDataDocument,
  removeBridgeDataDocument,
  removeBookingDoc
}
